import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import ReservaForm from "../components/reservas"; // ajusta la ruta
import ProductosVitrina from "../components/vitrina";  // nuevo componente
import "../styles/reservas.css";

const Servicios = () => {
  const [showReservas, setShowReservas] = useState(false);
  const [showProductos, setShowProductos] = useState(false); // nuevo estado

  return (
    <section className="reservas-section">
    <Container className="text-center">
  <h1 className="menu-title">Servicios</h1>

  {/* Contenedor de botones alineados */}
  <div className="d-flex justify-content-center gap-3 my-4">
    {/* Botón reservas */}
    <Button
      className={`menu-show-btn ${showReservas ? "active" : ""}`}
      onClick={() => setShowReservas((prev) => !prev)}
    >
      {showReservas ? "Ocultar reservas" : "Ver reservas"}
    </Button>

    {/* Botón productos */}
    <Button
      className={`menu-show-btn ${showProductos ? "active" : ""}`}
      onClick={() => setShowProductos((prev) => !prev)}
    >
      {showProductos ? "Ocultar productos" : "Venta de productos"}
    </Button>
  </div>

  {/* Mostrar contenido debajo */}
  {showReservas && (
    <div className="mt-4">
      <ReservaForm />
    </div>
  )}

  {showProductos && (
    <div className="mt-4">
      <ProductosVitrina />
    </div>
  )}
</Container>

    </section>
  );
};

export default Servicios;
